import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import Dimmer from "semantic-ui-react/dist/es/modules/Dimmer";
import Loader from "semantic-ui-react/dist/es/elements/Loader";
import NavbarContainer from "../../Navbar/NavbarContainer";
import DataIcon from "../../../assets/svg/querybuilder.svg";
import { tiktokAuthentication, twitterAuthenticate, linkedinAuthentication, getLinkedinPages } from "../../../actions/tokensAction";
import { Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import "./Tokens.scss";
import LinkedinPageSelectionModal from "./LinkedinPageSelectionModal";

function SocialTokensTwitterOAuth(props) {
    const dispatch = useDispatch();
    const tiktokLoginStatus = useSelector((state) => state.tokensReducer.tiktokLoginStatus);
    const tiktokAuthenticationFailed = useSelector((state) => state.tokensReducer.tiktokAuthenticationFailed);
    const linkedinLoginStatus = useSelector((state) => state.tokensReducer.linkedinLoginStatus);
    const linkedinAuthenticationFailed = useSelector((state) => state.tokensReducer.linkedinAuthenticationFailed);
    const linkedinPageLists = useSelector((state) => state.tokensReducer.linkedinPages || []);
    const linkedinAccessToken = useSelector((state) => state.tokensReducer.linkedinAccessToken);
    const linkedinExpiresIn = useSelector((state) => state.tokensReducer.linkedinExpiresIn);

    const company = useSelector((state) => state.globalReducer.company);
    const sidebarExpanded = useSelector((state) => state.globalReducer.sidebarExpanded);

    const initialState = {
        loginStatus: false,
        authenticationFailed: false,
    };

    const [authFailed, setAuthFailed] = useState(false);
    const [platformLoginStatus, setPlatformLoginStatus] = useState(initialState);
    const [headerName, setHeaderName] = useState("Radarr");
    // const [openLinkedinModal, setOpenLinkedinModal] = useState(false);
    const [selectedLinkedinPages, setSelectedLinkedinPages] = useState([]);
    // const state = new URLSearchParams(window.location.search).get("state").split(",").includes("tiktok");
    const state = window.location.href.indexOf("tiktok") > 0;

    useEffect(async () => {
        // this.props.company.is_profile_setup !== 1
        if (window.location.href.indexOf("?oauth_token=") > 0 || window.location.href.indexOf("?oauth_verifier=") > 0) {
            const url = window.location;
            const oAuthToken = new URLSearchParams(url.search).get("oauth_token");
            const oAuthVerifier = new URLSearchParams(url.search).get("oauth_verifier");
            let param = {};
            param["oauth_token"] = oAuthToken;
            param["oauth_verifier"] = oAuthVerifier;
            // if (Object.keys(param).length !== 0)
            props.twitterAuthenticate(param);
        } else if (window.location.href.indexOf("socialToken") > 0) {
            let redirectOnError =
                company.is_profile_setup !== 1
                    ? "/profile-setup/social-profiles"
                    : window.location.href.includes("smpDashboard")
                    ? "/social-media-publishing/settings/accounts"
                    : window.location.href.includes("smrPage")
                    ? "/social-response/settings/accounts"
                    : "/social-tokens";

            const url = window.location;
            const linkedinCode = new URLSearchParams(url.search).get("code");
            const redirectURl = window.location.href.split("?")[0];
            let params = {};
            params["code"] = linkedinCode;
            // params["token_source"] = "app";
            params["redirect_url"] = redirectURl;

            dispatch(getLinkedinPages(params)).then((res) => {
                if (res.value.access_token || res.value.expires_in) {
                    // setOpenLinkedinModal(true)
                    if (res.value?.pages?.length < 1) {
                        toast.error("You do not have any LinkedIn Page");
                        props.history.push(redirectOnError);
                    }
                } else {
                    toast.error("Error in Authenticating");
                    props.history.push(redirectOnError);
                }
            });
            // dispatch(linkedinAuthentication(params));
        } else if (window.location.href.indexOf("?code=") > 0) {
            // let codeURL = window.location.href.split("=");
            let params = {};
            // if (codeURL[1]) {
            const parsedUrl = new URL(window.location.href);
            const codeVal = parsedUrl.searchParams.get("code");

            params["token_source"] = "app";
            // params["code"] = codeURL[1];
            params["code"] = codeVal;
            const disFn = await dispatch(tiktokAuthentication(params));
            // }
        }

        if (window.location.href.indexOf("?error") > 0 || window.location.href.includes("error")) {
            setAuthFailed(!authFailed);
            toast.error("Your authorization is failed");
        }
    }, []);

    useEffect(() => {
        if (state) {
            setHeaderName("TikTok OAuth");
            setPlatformLoginStatus({
                loginStatus: tiktokLoginStatus,
                authenticationFailed: tiktokAuthenticationFailed,
            });
        } else if (window.location.href.includes("socialToken")) {
            //linkedin
            setHeaderName("LinkedIn OAuth");
            setPlatformLoginStatus({
                loginStatus: linkedinLoginStatus,
                authenticationFailed: linkedinAuthenticationFailed,
            });
        } else {
            setHeaderName("X OAuth");
            setPlatformLoginStatus({
                loginStatus: props.twitterLoginStatus,
                authenticationFailed: props.twitterAuthenticationFailed,
            });
        }
    }, [
        tiktokLoginStatus,
        tiktokAuthenticationFailed,
        props.twitterLoginStatus,
        props.twitterAuthenticationFailed,
        linkedinLoginStatus,
        linkedinAuthenticationFailed,
    ]);

    const storeLinkedinPages = () => {
        let params = {};
        let pages = linkedinPageLists
            .filter((pageObj) => selectedLinkedinPages.includes(+pageObj.page_id))
            .map((obj) => {
                let newObj = obj;
                newObj["page_id"] = obj.page_id + "";
                return newObj;
            });

        params["token_source"] = "app";
        params["access_token"] = linkedinAccessToken;
        params["expires_in"] = linkedinExpiresIn + "";
        params["scopes"] = "r_liteprofile,r_emailaddress,rw_organization_admin,r_organization_social,r_basicprofile,w_member_social,w_organization_social";
        params["pages"] = pages;
        // console.log("pages", params);
        dispatch(linkedinAuthentication(params));
    };

    let redirectUrl =
        company.is_profile_setup !== 1
            ? "/profile-setup/social-profiles"
            : window.location.href.includes("smpDashboard")
            ? "/social-media-publishing/settings/accounts"
            : window.location.href.includes("smrPage")
            ? "/social-response/settings/accounts"
            : "/social-tokens";

    // console.log("firstxx",redirectUrl)
    return (
        <div className={`twitterInsightsOAuth ${sidebarExpanded ? "sidebar-expanded" : "sidebar-collapsed"}`}>
            <NavbarContainer history={props.history} location={props.location} pageTitle={headerName} icon={DataIcon} />
            <div className="twitteroauth__main">
                <div className="page__text">Authenticating</div>
                <div className="list-loading">
                    <Dimmer inverted active>
                        <Loader size="big" className="skiptranslate">
                            Loading
                        </Loader>
                    </Dimmer>
                </div>
            </div>
            {linkedinPageLists?.length > 0 ? (
                <LinkedinPageSelectionModal
                    open
                    selectedPages={selectedLinkedinPages}
                    setPageList={setSelectedLinkedinPages}
                    storePage={storeLinkedinPages}
                    redirectOnError={redirectUrl}
                />
            ) : null}
            {/* {props.twitterLoginStatus && toast.success("Authentication successful") && <Redirect to="/social-tokens" />}
            {props.twitterAuthenticationFailed && <Redirect to="/social-tokens" />} */}
            {platformLoginStatus.loginStatus && toast.success("Authentication successful") && <Redirect to={redirectUrl} />}
            {(authFailed || platformLoginStatus.authenticationFailed) && <Redirect to={redirectUrl} />}
        </div>
    );
}
const mapStateToProps = (state) => {
    return {
        twitterLoginStatus: state.tokensReducer.twitterLoginStatus,
        twitterAuthenticationFailed: state.tokensReducer.twitterAuthenticationFailed,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        twitterAuthenticate: (data) => dispatch(twitterAuthenticate(data)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(SocialTokensTwitterOAuth);
